import React from 'react';

import { TablePaginationProps } from './Table.type';

const TablePagination = (props: TablePaginationProps) => {
	const recordsCountFrom =
		props.rows.length > 0 ? props.pageIndex * props.pageSize + 1 : 0;
	const recordsCountTo =
		recordsCountFrom > 0 ? recordsCountFrom + props.page.length - 1 : 0;
	return (
		<div className="flex justify-between items-center mt-6">
			<div className="text-large text-gray-gray700 font-interRegular">
				Menampilkan {recordsCountFrom} - {recordsCountTo} dari{' '}
				{props.rows.length} data
			</div>
			<div className="flex justify-center items-center">
				<div className="flex justify-center items-center mr-6">
					<button
						className={
							!props.canPreviousPage
								? 'w-25 h-14 flex justify-center items-center border-1.5 border-gray-gray500 rounded-lg cursor-default'
								: 'w-25 h-14 flex justify-center items-center border-1.5 border-primary-green rounded-lg'
						}
						onClick={() => props.gotoPage(0)}
						disabled={!props.canPreviousPage}
					>
						{!props.canPreviousPage ? (
							<img src="/images/chevronLeftGrey.svg" />
						) : (
							<img src="/images/chevronLeftGreen.svg" />
						)}
						<div
							className={
								!props.canPreviousPage
									? 'text-large text-gray-gray500 font-interRegular'
									: 'text-large text-primary-green font-interRegular'
							}
						>
							Awal
						</div>
					</button>
					<button
						className={
							!props.canPreviousPage
								? 'w-14 h-14 flex justify-center items-center border-1.5 border-gray-gray500 rounded-lg ml-2 cursor-default'
								: 'w-14 h-14 flex justify-center items-center border-1.5 border-primary-green rounded-lg ml-2'
						}
						onClick={props.previousPage}
						disabled={!props.canPreviousPage}
					>
						{!props.canPreviousPage ? (
							<img src="/images/chevronLeftGrey.svg" />
						) : (
							<img src="/images/chevronLeftGreen.svg" />
						)}
					</button>
					<button
						className={
							!props.canNextPage
								? 'w-14 h-14 flex justify-center items-center border-1.5 border-gray-gray500 rounded-lg ml-2 cursor-default'
								: 'w-14 h-14 flex justify-center items-center border-1.5 border-primary-green rounded-lg ml-2'
						}
						onClick={props.nextPage}
						disabled={!props.canNextPage}
					>
						{!props.canNextPage ? (
							<img src="/images/chevronRightGrey.svg" />
						) : (
							<img src="/images/chevronRightGreen.svg" />
						)}
					</button>
					<button
						className={
							!props.canNextPage
								? 'w-25 h-14 flex justify-center items-center border-1.5 border-gray-gray500 rounded-lg ml-2 cursor-default'
								: 'w-25 h-14 flex justify-center items-center border-1.5 border-primary-green rounded-lg ml-2'
						}
						onClick={() => props.gotoPage(props.pageCount - 1)}
						disabled={!props.canNextPage}
					>
						<div
							className={
								!props.canNextPage
									? 'text-large text-gray-gray500 font-interRegular'
									: 'text-large text-primary-green font-interRegular'
							}
						>
							Akhir
						</div>
						{!props.canNextPage ? (
							<img src="/images/chevronRightGrey.svg" />
						) : (
							<img src="/images/chevronRightGreen.svg" />
						)}
					</button>
				</div>
				<div className="text-large text-gray-gray700 font-interRegular">
					Halaman
					<span className="text-large text-gray-gray700 font-interMedium mx-1">
						{props.pageIndex + 1}
					</span>
					dari
					<span className="text-large text-gray-gray700 font-interMedium ml-1">
						{props.pageOptions.length > 0 ? props.pageOptions.length : 1}
					</span>
				</div>
			</div>
		</div>
	);
};

export default TablePagination;
